module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Map/Compass-f3ad75b11d800caac39a988802b09f25.svg";